export default __webpack_public_path__ + "img/reject-66fd4380.png";